var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon-pin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "20px",
    width: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#969696;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.4,0.3c-0.6-0.6-1.5-0.6-2.1,0l-9.7,9.7c-24.9,24.9-28.9,63-11.9,92.1c0.4,0.7,0.2,1.5-0.4,1.9 l-106.6,72.1c-0.6,0.4-1.4,0.3-1.8-0.2l-1-1c-41.5-41.5-109-41.5-150.5,0l-9.7,9.7c-0.6,0.6-0.6,1.5,0,2.1l133,133 c0.6,0.6,0.6,1.5,0,2.1L4.5,485.8c-6,6-6,15.7,0,21.7l0.3,0.3c5.7,5.7,15,5.7,20.7,0l164.6-164.6c0.6-0.6,1.5-0.6,2.1,0l133,133 c0.6,0.6,1.5,0.6,2.1,0l8.7-8.7c42.1-42.1,42.1-110.4,0-152.6l0,0c-0.5-0.5-0.6-1.3-0.2-1.8l72.1-106.6c0.4-0.6,1.3-0.8,1.9-0.4 c29.1,17,67.1,13,92.1-11.9l9.7-9.7c0.6-0.6,0.6-1.5,0-2.1L329.4,0.3z M323.9,431.9l-244-244c-0.7-0.7-0.5-1.8,0.2-2.3 c29.3-18.4,68.6-14.9,94.2,10.7l141.2,141.2c25.5,25.5,29.1,64.8,10.7,94.2C325.7,432.5,324.6,432.6,323.9,431.9z M312,291 l-91.1-91.1c-0.6-0.6-0.5-1.7,0.2-2.2l104.5-70.6c0.6-0.4,1.4-0.3,1.8,0.2l57.2,57.2c0.5,0.5,0.6,1.3,0.2,1.8l-70.6,104.5 C313.7,291.6,312.6,291.7,312,291z M415.8,172.7L339.2,96c-13.5-13.5-16.7-33.4-9.8-49.9c0.4-1,1.6-1.2,2.4-0.5l134.5,134.5 c0.7,0.7,0.5,2-0.5,2.4C449.2,189.4,429.3,186.2,415.8,172.7L415.8,172.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.6ba5e0148d1a4a915736bdbd6a2f856f.svg";
export { ForwardRef as ReactComponent };